export const strcmp = (str1, str2) => str1.toLowerCase().trim().includes(str2);
